const getAttachedFilesFromInputs = () => {
  const imageInput = document.querySelector('[data-review-input="photos"]');
  const videoInput = document.querySelector('[data-review-input="video"]');

  if (imageInput && videoInput) return [...imageInput.files, ...videoInput.files];
  return [];
};

const createComponent = (file, isVideo = false) => {
  const { name: fileName } = file;
  const fileURL = URL.createObjectURL(file);
  return `
    <div class="goodscard-reviews__attached-file ${isVideo ? 'video _with-blur' : ''}" data-file-name="${fileName}">
      <button class="goodscard-reviews__attached-file-close"></button>
      <div class="full-screen-viewer">
        <${isVideo ? 'video width="96" height="96" muted' : 'img'} src="${fileURL}#t=0.001" alt="">
      </div>
    </div>
  `;
};

const createPageCode = (files) => files.reduce((acc, file) => {
  const fileComponent = createComponent(file, file.type.startsWith('video'));
  const res = acc + fileComponent;
  return res;
}, '');

const removelFileFromPage = (fileName) => {
  const fileElement = document.querySelector(`[data-file-name="${fileName}"]`);
  if (fileElement) fileElement.parentNode.removeChild(fileElement);
};

const sortFiles = (files) => {
  const MB_5 = 1024 * 1024 * 5;
  const MB_200 = 1024 * 1024 * 200;

  const imagesTransfer = new DataTransfer();
  const videoTransfer = new DataTransfer();

  let isVideoAdded = false;
  const errorFilesNames = [];

  [...files].forEach((file) => {
    if (imagesTransfer.files.length < 10 && file.type.startsWith('image')) {
      if (file.size < MB_5) imagesTransfer.items.add(file);
      else errorFilesNames.push(file.name);
    }
    if (!isVideoAdded && file.type.startsWith('video')) {
      if (file.size < MB_200) {
        videoTransfer.items.add(file);
        isVideoAdded = true;
      } else errorFilesNames.push(file.name);
    }
  });

  if (errorFilesNames.length) {
    const popupTitle = '<h2 class="popup__title">Ошибка</h2>';
    let description = errorFilesNames.length === 1
      ? 'Размер файла больше допустимого:'
      : 'Размер файлов больше допустимого:';

    errorFilesNames.forEach((el) => {
      description += `<br>${el}`;
    });

    description += errorFilesNames.length === 1
      ? '<br>Попробуйте загрузить другой файл'
      : '<br>Попробуйте загрузить другие файлы';
    window.popupOpenUniversalForm(popupTitle, description);
  }

  return {
    photos: imagesTransfer,
    video: videoTransfer,
  };
};

const addPhotos = (photos, removeOldPhotos = false) => {
  const imageInput = document.querySelector('[data-review-input="photos"]');

  if (!imageInput.files.length || removeOldPhotos) imageInput.files = photos.files;
  else {
    const additionalDS = new DataTransfer();
    let filesCounter = imageInput.files.length;

    [...photos.files].forEach((file) => {
      const files = [...imageInput.files];
      const hasFile = files.some((el) => el.name === file.name);
      if (filesCounter < 10 && !hasFile) {
        additionalDS.items.add(file);
        filesCounter++;
      }
    });

    const resultDS = new DataTransfer();
    [...imageInput.files, ...additionalDS.files].forEach((file) => {
      resultDS.items.add(file);
    });

    imageInput.files = resultDS.files;
    return additionalDS.files;
  }
  return imageInput.files;
};

const addVideo = (video, removeOldVideo = false) => {
  const videoInput = document.querySelector('[data-review-input="video"]');

  if (!videoInput.files.length || removeOldVideo) {
    videoInput.files = video.files;
    return videoInput.files;
  }
  return new DataTransfer().files;
};

const deleteButtonHandler = (e) => {
  e.preventDefault();

  const parentElem = e.target.closest('[data-file-name]');
  const { fileName } = parentElem.dataset;
  const files = getAttachedFilesFromInputs();
  if (files.length) {
    const filesWithoutDeleted = files.filter((file) => file.name !== fileName);
    const sortedFiles = sortFiles(filesWithoutDeleted);
    addPhotos(sortedFiles.photos, true);
    addVideo(sortedFiles.video, true);
    removelFileFromPage(fileName);
  }
};

const addDeleteHandlers = () => {
  const deleteButtons = document.querySelectorAll('.goodscard-reviews__attached-file-close');

  deleteButtons.forEach((el) => {
    if (!el.classList.contains('_init')) {
      el.addEventListener('click', deleteButtonHandler);
      el.classList.add('_init');
    }
  });
};

const addAttachedFilesOnPage = (attachedFilesComponents = '') => {
  const attachedFileContainer = document.querySelector('.goodscard-reviews__attached-block');

  if (attachedFileContainer) {
    const parser = new DOMParser();
    const html = parser.parseFromString(attachedFilesComponents, 'text/html');
    const divs = html.body.querySelectorAll('.goodscard-reviews__attached-file');
    divs.forEach((div) => attachedFileContainer.appendChild(div));
    attachedFileContainer.classList.remove('_empty');
  }
};

const addFiles = (files) => {
  const sortedFiles = sortFiles(files);
  const addedFiles = [...addPhotos(sortedFiles.photos), ...addVideo(sortedFiles.video)];

  const pageCode = createPageCode(addedFiles);
  addAttachedFilesOnPage(pageCode);
  addDeleteHandlers();
  window.fullScreenViewer();
};

const init = () => {
  const attachFilesPopup = document.querySelector('#attach-file');
  const fileInput = document.querySelector('#attachFileInput');

  fileInput.addEventListener('input', (e) => {
    e.preventDefault();

    addFiles(e.target.files);
    e.target.value = '';
    window.popupClose(attachFilesPopup);
  });

  const popupBody = attachFilesPopup.querySelector('.popup__content');

  attachFilesPopup.addEventListener('dragover', (e) => {
    e.preventDefault();

    attachFilesPopup.classList.add('_dragover');
  });
  attachFilesPopup.addEventListener('dragleave', (e) => {
    e.preventDefault();

    if (!e?.fromElement?.classList.contains('attach-file__drop-zone')
      && !e.target.closest('.popup__content')) attachFilesPopup.classList.remove('_dragover');
  });

  popupBody.addEventListener('drop', (e) => {
    e.preventDefault();
    e.stopPropagation();

    addFiles(e.dataTransfer.files);
    window.popupClose(attachFilesPopup);
    setTimeout(() => {
      attachFilesPopup.classList.remove('_dragover');
    }, 200);
  });
};

window.attachFilesInit = init;
